/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Auto_Draft_ButtonInputs */

const en_case_create_auto_draft_button = /** @type {(inputs: Case_Create_Auto_Draft_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process Documents`)
};

const pt_br2_case_create_auto_draft_button = /** @type {(inputs: Case_Create_Auto_Draft_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processar documentos`)
};

/**
* | output |
* | --- |
* | "Process Documents" |
*
* @param {Case_Create_Auto_Draft_ButtonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_auto_draft_button = /** @type {((inputs?: Case_Create_Auto_Draft_ButtonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Auto_Draft_ButtonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_auto_draft_button(inputs)
	return pt_br2_case_create_auto_draft_button(inputs)
});